import React, { useEffect, useState } from 'react';
import "./CSS/ShopCategory.css";
import Item from "../Components/Items/Item";
import { useProductStore } from "../stores/useProductStores";
import { useParams } from "react-router-dom";

const ShopCategory = ({ category: categoryProp }) => {
  const { category: categoryParam } = useParams();
  const category = categoryParam || categoryProp;
  const { productsCategory, newProducts, getProductsByCategory, getNewCollections } = useProductStore();
  
  useEffect(() => {
    if (category === "new") {
      getNewCollections();
    } else {
      getProductsByCategory(category);
    }
  }, [category, getNewCollections, getProductsByCategory]);

  const productsToDisplay = category === "new" ? newProducts : productsCategory;

  // Step 1: Add a state for sorting option
  const [sortOption, setSortOption] = useState("default");

  // Step 2: Sorting logic using productsToDisplay
  const sortedProducts = [...productsToDisplay].sort((a, b) => {
    switch (sortOption) {
      case "price_asc":
        return a.price - b.price; // Make sure `price` is correctly referenced
      case "price_desc":
        return b.price - a.price;
      case "name_asc":
        return a.name.localeCompare(b.name);
      case "name_desc":
        return b.name.localeCompare(a.name);
      default:
        return 0; // Default: no sorting
    }
  });

  return (
    <div className="shop-category">
      <div className="shopcategory-indexSort">
        <p>
          <span>Showing {sortedProducts.length} products</span>
        </p>
        <div className="shopcategory-sort">
          <span>Sort by</span>
          <select value={sortOption} onChange={(e) => setSortOption(e.target.value)}>
            <option value="default">Default</option>
            <option value="price_asc">Price: Low to High</option>
            <option value="price_desc">Price: High to Low</option>
            <option value="name_asc">Name: A to Z</option>
            <option value="name_desc">Name: Z to A</option>
          </select>
        </div>
      </div>

      <div className="shopcategory-products">
        {sortedProducts.length > 0 ? (
          sortedProducts.map((item, i) => (
            <Item key={item.id || i} id={item.id} name={item.name} image={item.image} price={item.price} availableQuantity={item.available_quantity} />
          ))
        ) : (
          <p>No products found.</p>
        )}
      </div>


    </div>
  );
};

export default ShopCategory;
